import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { useListScheduledQueries } from '@terminal/react-query-hooks/alfred/useScheduledQueries';
import { useTranslation } from 'react-i18next';

import { ScheduledTaskItem } from './ScheduledTaskItem';
import styles from './ScheduledTaskList.module.scss';

const ScheduledTaskListSkeleton = () => (
  <div className={styles.skeleton}>
    {[200, 160, 220].map(width => (
      <SkeletonLoader
        key={width}
        areas={[
          {
            styles: {
              width: `${width}px`,
              height: '16px',
              borderRadius: '8px',
              marginLeft: '10px',
              marginTop: '2px',
            },
          },
        ]}
      />
    ))}
  </div>
);

export const ScheduledTaskList = () => {
  const { t } = useTranslation(['chat']);
  const { data, isLoading } = useListScheduledQueries({ status: 'active' });

  if (isLoading) {
    return <ScheduledTaskListSkeleton />;
  }

  const tasks = data?.scheduled_queries ?? [];

  if (tasks.length === 0) {
    return (
      <div className={styles.emptyState} data-testid="scheduled-empty-state">
        <img
          src="/app/static/images/empty-state/complete-research-reports.svg"
          alt=""
          className={styles.emptyIllustration}
          width={80}
          height={80}
        />
        <div className={styles.emptyText}>
          <p className={styles.emptyTitle}>
            {t('chat:historyTab.scheduledEmptyTitle')}
          </p>
          <p className={styles.emptyDescription}>
            {t('chat:historyTab.scheduledEmptyDescription')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="scheduled-task-list">
      <h4 className={styles.sectionLabel}>
        {t('chat:historyTab.scheduledTasks')}
      </h4>
      {tasks.map(task => (
        <ScheduledTaskItem key={task.id} task={task} />
      ))}
    </div>
  );
};
